import Component from '../core/Component'

export default class Input extends Component {
    prepare() {
        this.element.addEventListener('input', this.handleInput)
    }

    handleInput = event => {
        this.element.classList.toggle('is-filled', this.element.value.trim())
    }
}
